<template>
  <div data-qa="addpaymentdialog-div-fivjr5">
    <v-overlay v-if="loaderEnabled" :opacity="0.5" data-qa="addpaymentdialog-overlay-jpdl2v">
      <v-progress-circular :color="primaryColor" :size="70" :width="7" indeterminate class="circular-loader" data-qa="addpaymentdialog-progress-circular-2r3uoc">
      </v-progress-circular>
    </v-overlay>
    <Modal
      v-if="config.showConfimModal"
      :config="{...modalConfig.confirmSaveMandates, title:modalTitle,
              btn1Label: config.action === 'fail' && errors
                ? $t('accountMandates.button.retryBtn')
                : $t('accountMandates.button.viewMandates'),
                body: confirmSaveMandatesBody}"
      @btn1Action="config.action === 'fail' && errors ? closeDialogBox()
                  : routeToAccountMandates()"
      @btn2Action="routeToDashboard()">
        <span slot='modalContent' class='font-weight-medium'
            style="display: block; margin-bottom: 30px;"
            v-if="config.action === 'fail' && errors" data-qa="addpaymentdialog-span-l7kh0b">
          {{ $t("accountMandates.info.saveFailInfo") }}
        </span>
        <span slot='modalContent' class='font-weight-medium red--text'
          style="display: block;"
          v-show="config.action === 'fail' && errors && errors.length"
          v-for="(item, i) in errors" :key="item.code" :data-qa="`addpaymentdialog-span-0lso50-${i}`">
          {{ item.message }}
        </span>
        <span slot='modalContent' class='font-weight-medium "red--text'
              v-if="config.action === 'fail' && !errors" data-qa="addpaymentdialog-span-0lso4o">
          {{ $t("accountMandates.errorMsg.apiReqFail") }}
        </span>
    </Modal>
  </div>
</template>

<script>
import event from '@/util/event'
import Modal from '@/components/common/Modal.vue'

export default {
  name: 'AddPaymentDialog',
  balance: 0,
  components: {
    Modal
  },
  props: {
    config: Object
  },
  data () {
    return {
      modalConfig: {
        confirmSaveMandates: {
          enabled: true,
          persistent: true,
          btn2Label: this.$t('common.goToDashboardBtnLabel'),
          width: 650
        }
      },
      errors: []
    }
  },
  created () {
    this.loaderEnabled = !this.config.showConfimModal
    if (this.config.causes) {
      this.getCauses()
    } else {
      event.$emit('mandatePristineSave', true)
    }
    event.$emit('closeSavingsAccountSanity', false)
  },
  updated () {
    this.loaderEnabled = !this.config.showConfimModal
    if (this.config.causes) {
      this.getCauses()
    } else {
      event.$emit('mandatePristineSave', true)
    }
  },
  computed: {
    modalTitle () {
      return this.config.action === 'success'
        ? this.$t('accountMandates.info.saveSuccess')
        : this.$t('accountMandates.errorMsg.saveFailed')
    },
    confirmSaveMandatesBody () {
      return this.config.action === 'success'
        ? this.$t('accountMandates.subtitleSaveMandate')
        : ''
    }
  },
  methods: {
    routeToDashboard () {
      setTimeout(() => {
        this.$router.push({
          path: '/home'
        })
      }, 600)
    },
    routeToAccountMandates () {
      setTimeout(() => {
        this.config.showConfimModal = false
        this.$emit('closePaymentDialog', true)
      }, 600)
    },
    closeDialogBox () {
      this.config.showConfimModal = false
    },
    getCauses () {
      const status = this.config.status
      switch (status) {
        case 500:
          this.errors = ''
          break
        case 400:
          this.errors = this.config.causes
          break
        default:
          this.errors = this.config.causes
          break
      }
    },
    getIcon (action) {
      if (action === 'success') {
        return this.getSvgIconSrc('Success')
      }
      if (action === 'fail') {
        return this.getSvgIconSrc('Error')
      }
    }
  }
}
</script>
